import { render, staticRenderFns } from "./detalleHistorial.vue?vue&type=template&id=25d9ea00&scoped=true"
import script from "./detalleHistorial.vue?vue&type=script&lang=js"
export * from "./detalleHistorial.vue?vue&type=script&lang=js"
import style0 from "./detalleHistorial.vue?vue&type=style&index=0&id=25d9ea00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d9ea00",
  null
  
)

export default component.exports